module.exports = __webpack_public_path__ + "static/media/407SunsetAveNW_2018-06-11_66.cb69ca82.jpg";